import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { ModalTemplateDirective } from '@shared/components/modal/modal-template.directive';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ToastComponent } from '@shared/components/toast/toast.component';
import { MaintenancePageComponent } from '@shared/pages/maintenance-page/maintenance-page.component';
import { MaintenanceService } from '@shared/services/maintenance.service';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [
    LoadingComponent,
    ModalTemplateDirective,
    ModalComponent,
    ToastComponent,
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
    MaintenancePageComponent,
  ],
})
export class AppComponent {
  private readonly ngbTooltipConfig = inject(NgbTooltipConfig);
  public readonly maintenanceService = inject(MaintenanceService);

  public constructor() {
    this.ngbTooltipConfig.animation = false;
  }
}
